export { default as FeatureFlagBooleanContainer } from './FeatureFlagBooleanContainer';
export { default as FeatureFlagOn } from './FeatureFlagOn';
export { default as FeatureFlagOff } from './FeatureFlagOff';
export {
  useFeatureFlag,
  getAllFeatureFlags,
  hasFeatureFlag,
  getFeatureFlagValue,
  getCurrentEnvironmentName,
  getAvailableEnvironments,
} from './useFeatureFlag';
export { useServerFlagsResolved } from './useServerFlagsResolved';
export { useFeatureFlagsReady } from './react';

/** Centralized feature flag keys — use these instead of inline strings. */
export const FEATURE_FLAG_KEYS = {
  HIDE_RATING_REPLY: 'hideRatingReply',
  ONBOARDING_TOURS: 'onboardingTours',
  /** Overall standings + duel match GFX generators (Story/Post PNG export). */
  STANDINGS_GRAPHIC_GENERATOR: 'standingsGraphicGenerator',
  BUY_EC: 'buyEC',
  /**
   * Sensitive tier (server-resolved by region — see serverFlags.ts). NOT in
   * the CDN file or bundled env.json: absent until the server push = false =
   * fail closed. buyEC stays the global kill switch. Gates ALL crypto
   * surfaces: buy EC with crypto (Trails/USDT) and the crypto wallet
   * (address, balances, swap, withdraw/cash-out). Card checkout is never
   * region-gated.
   */
  BUY_EC_CRYPTO: 'buyECCrypto',
  /**
   * Public team profile pages (`/team-profile/:id` + achievements/history) and the Team Detail
   * "View profile" entry. Off (or absent from the CDN file) = entry hidden and routes redirect home.
   */
  TEAM_PROFILE_WEB: 'teamProfileWeb',
} as const;

// Export types
export type {
  EnvironmentFlags,
  FeatureFlags,
  UseFeatureFlagReturn,
  FeatureFlagBooleanContainerProps,
  FeatureFlagBooleanContainerState,
  FeatureFlagOnProps,
  FeatureFlagOffProps,
  EnvironmentInfo,
} from './types';
